import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Success from '../../../shared/images/backgrounds/success.png';
import GeneralError from '../../../shared/images/backgrounds/general-error.png';
import styles from './licenceError.module.scss';

export default memo(function LicenceError(props) {
    const { t } = useTranslation('wizard');

    return (
        <div className={styles.container}>
            <img alt="licence-error" height="150" src={props.errorCode === 412 ? Success : GeneralError} width="250" />
            {
                props.errorCode === 412 &&
                <>
                    <span>{t('LICENCE_ALREADY_ACTIVATED')}</span>
                    <span>{t('SUPPORT')}</span>
                </>
            }
            {props.errorCode !== 412 && <span className={styles.message}>{t('LICENCE_ERROR')}</span>}
        </div>
    )
});
